const ctaList = document.querySelector('.cta-links ul');

if (ctaList) {
    const ctaItem = ctaList.querySelectorAll('li');
    if (ctaItem.length >= 4) {
        ctaList.classList.add('extra-column');
    }
}